import { Box } from "@mui/material";
import AreaSelector from "./map/AreaSelector";

const GeographyChart = ({ isDashboard = false }) => {
  return (
    <Box width={isDashboard? "59%" : "70%"} maxWidth="230px" >
      <AreaSelector/>
    </Box>
  );
};

export default GeographyChart;